import ButtonUpload from "./ButtonUpload";
export default ButtonUpload;
